import React from 'react';
import '../less/main.less';
import clearBR from "../../../../helpers/utils/clearBR";


export default function template() {
    const {isMobile, page, data} = this.props;

  const questions = data.map((item, index)=> {
    const question = isMobile ? clearBR(this.l10n(item.question)) : this.l10n(item.question);
        return (
            <div key={index} className="question">
              <a href={`#${item.id}`} dangerouslySetInnerHTML={{ __html: question}}></a>
            </div>
        )
      }),
    answers = data.map((item, index)=> {
      const question = clearBR(this.l10n(item.question));
      const answer = isMobile ? clearBR(this.l10n(item.answer)) : this.l10n(item.answer);
      return (
        <div key={item.id}>
          <div className="anchor" id={item.id}></div>
          <div key={index} className="answer">
            <div className="answer-title" dangerouslySetInnerHTML={{ __html: question}}></div>
            <div className="answer-text" dangerouslySetInnerHTML={{ __html: answer}}></div>
          </div>
        </div>
      )
    });

    return (
        <div className={`${page}-wrapper question-block`}>
          <div className="left-side">
            {questions}
          </div>
          <div className="right-side">
            {answers}
          </div>

        </div>
    );
}
